#import "../../LookupCorporateAccountFields.graphql"
mutation LookupCorporateAccountUpdate(
  $input: LookupCorporateAccountUpdateInput!
) {
  lookupCorporateAccountUpdate(input: $input) {
    lookupCorporateAccount {
      ...LookupCorporateAccountFields
    }
  }
}
